<template>
    <div class="message-attach-list">
        <div class="attachments">
            <slot v-for="attachment in message.attachments.items" :key="attachment.name">
              <div v-if="attachment.type !== 'image'" class="attach-item" :class="'type-' + attachment.type" aria-label="Anexo">
                  <div >
                      <span>{{attachment.name}}<small>{{attachment.size}}</small></span>
                  </div>
              </div>
           </slot>
       </div>
    </div>

    <div class="message-attach-list attachments-thumbs">
        <div class="attachments">
            <slot v-for="attachment in message.attachments.items" :key="attachment.name">
                <div v-if="attachment.type === 'image'" class="attach-item" :class="'type-' + attachment.type" aria-label="Anexo">
                    <div>
                        <img :src="attachment.thumbnail_url">
                        <span>{{attachment.name}}<small>{{attachment.size}}</small></span>
                    </div>
                </div>
            </slot>
       </div>
    </div>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language      from '@/js/Shared/Language/Language';

  const props = defineProps({
    message : {
      required : true,
    },
  })

</script>
